import axiosInstance from 'api/axiosInstance';
import { stringify } from 'query-string';
import type { IPaginationRequest, Paging } from 'types/pagination.types';
import type { DocumentItem } from 'types/repository.types';

const getRepoDocuments = (
  params: IPaginationRequest,
): Promise<{ paging: Paging; repositoryDocuments: DocumentItem[] }> =>
  axiosInstance.get(
    `/v2/repository-documents?${stringify(params, {
      skipEmptyString: true,
      arrayFormat: 'comma',
    })}`,
  );

export default getRepoDocuments;
